// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-text {
	font-size: 1.1rem;
	font-weight: 600;
	margin-left: -15px;
	margin-right: 10px;
	margin-bottom: 0;
	color: var(--color-primary-green) !important;
	padding-top: 3px;
}

.sidebar-wrapper {
	width: 270px;
	height: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	background: var(--color-sidebar-bg);
	border-right: 1px solid var(--color-sidebar-border);
	z-index: 11;
	transition: all .2s ease-out
}

.sidebar-header {
	width: 270px;
	height: 45px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	bottom: 0;
	padding: 0 15px;
	z-index: 5;
	background: var(--color-sidebar-bg);
	background-clip: padding-box;
	border-bottom: 1px solid var(--color-sidebar-border);
}
@media screen and (max-width: 768px) {
	.sidebar-wrapper{
		width:100%;
	}
	.sidebar-header{
		width:100%;
	}
}

.sidebar-body{
	overflow-y:auto;
	height: calc(100% - 45px);
}
.sidebar-body::-webkit-scrollbar{
	width:10px;
}
.sidebar-body::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.menu-label {
	padding: 20px 15px 5px 5px;
	color: var(--color-menu-label);
	text-transform: uppercase;
	font-size: 1rem;
	letter-spacing: .5px
}

/* .metismenu .has-arrow:after {
	position: absolute;
	content: "";
	width: .5em;
	height: .5em;
	border-style: solid;
	border-width: 1.2px 0 0 1.2px;
	border-color: initial;
	right: 15px;
	transform: rotate(-45deg) translateY(-50%);
	transform-origin: top;
	top: 50%;
	transition: all .3s ease-out
} */

/* .has-arrow.open:after {
	transform: rotate(-180deg) ;
} */

.rightArrow{
	font-size: .7rem;
	position: absolute;
	top:35%;
	width: .5em;
	height: .5em;
	right: 15px;
	transition: transform .15s;
}
.arrow-flipped{
	transform: translateY(5px) rotate(180deg);
}

@media screen {
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 70px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {
		display: none
	}
	.email-toggle-btn {
		display: none!important
	}
	.chat-toggle-btn {
		display: none!important
	}
}

.sidebar-wrapper ul {
	padding: 0;
	margin: 0;
	list-style: none;
	background: 0 0
}

.sidebar-wrapper .metismenu {
	background: 0 0;
	display: flex;
	padding: 8px;
	padding-top:0;
	flex-direction: column
}

.sidebar-wrapper .metismenu li+li {
	margin-top: 2px
}

.sidebar-wrapper .metismenu li:first-child {
	margin-top: 5px
}

.sidebar-wrapper .metismenu li:last-child {
	margin-bottom: 5px
}
.sidebar-wrapper .metismenu>li {
	display: flex;
	flex-direction: column;
	position: relative
}

.sidebar-wrapper .metismenu a {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: left;
	padding: 8px 15px;
	font-size: 0.875rem;
	color: var(--color-menu-text);
	outline-width: 0;
	text-overflow: ellipsis;
	overflow: hidden;
	letter-spacing: .5px;
	border: 1px solid #ffffff00;
	transition: all .3s ease-out;
    text-decoration: none;
}

.parent-icon {
	color: var(--color-icon-slate);
	font-size: 14px;
	line-height: 1
}

.sidebar-wrapper .metismenu a .menu-title {
	margin-left: 10px;
	margin-top: 5px;
}

.sidebar-wrapper .metismenu ul a {
	padding: 6px 15px 6px 50px;
	font-size: 0.875rem;
	letter-spacing: .5px;
	border: 0
}


.sidebar-wrapper .metismenu ul {
	background: var(--color-sidebar-bg);
}

.sidebar-wrapper .metismenu ul ul a {
	padding: 8px 15px 8px 60px
}

.sidebar-wrapper .metismenu ul ul ul a {
	padding: 8px 15px 8px 45px
}

.sidebar-wrapper .metismenu li button:hover,
.sidebar-wrapper .metismenu li a:hover{
	background-color: var(--color-menu-hover-bg);
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu li button:hover .menu-title,
.sidebar-wrapper .metismenu li a:hover .menu-title{
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu li a,
.sidebar-wrapper .metismenu li button{
	border-radius: 6px;
}
.sidebar-wrapper .metismenu .mm-active>a,
.sidebar-wrapper .metismenu a:active,
.sidebar-wrapper .metismenu a:focus,
.sidebar-wrapper .metismenu a:hover {
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
	text-shadow: none;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    
	background-color: var(--color-menu-active-bg) !important;
    color: var(--color-menu-active-text) !important;
	text-shadow: none;
    border-left: 3px solid var(--color-menu-active-text) !important;
    border-radius: 6px;
}
.sidebar-wrapper .metismenu ul a i {
    margin-right: 10px;
    font-weight: 900;
}

.toggle-icon {
	font-size: 22px;
	cursor:pointer;
	color:var(--color-primary-orange);
	margin-left: 30px;
}
.toggle-icon i{
	margin-left: 70px;
}

.mm-collapse:not(.mm-show) {
    display: none;
}
.mm-collapse li i{
	font-size: 9px;
}
.mm-collapse .parent-icon i{
	font-size: 16px;
}
.mm-collapse.mm-show li .sidebar-button{
	width:100%;
}
.sidebar-button{
	position: relative;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 8px 15px;
    font-size: 0.875rem;
    color: var(--color-menu-text);
    outline-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: .5px;
    border: 1px solid #ffffff00;
    transition: all .3s ease-out;
    text-decoration: none;
	background: none;
}

.padding-left-12{
	padding-left: 12px;
}

.menu-title{
font-weight: 600 !important;
}
.sub-menu-title{
	/* padding-left:13px; */
	font-size:.9rem;
}

.dropdown-menu{
	border-radius: 0;
	background-color: var(--color-sidebar-bg);
	box-shadow: 0 4px 12px rgba(0,0,0,0.3);
	max-height: calc(100vh - 390px);
	overflow-y: auto;
	overflow-x: hidden;
	padding-top: 0;
	scrollbar-width: thin;
	scrollbar-color: var(--color-white-a50) transparent;
	scrollbar-gutter: stable;
}
.dropdown-item {
	white-space: nowrap;
}

.dropdown-menu::-webkit-scrollbar{
	width:10px;
	background-color: #3f4349;
}
.dropdown-menu::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.mm-collapse.mm-show .dropdown-item{
	padding-left: 40px;
}
.dropdown-item, .dropdown-item a{
	color: var(--color-menu-text);
	font-size: 0.875rem;
	letter-spacing: .5px;
	height:50px;
	line-height: 52px;
	padding: 0 1rem;
	text-decoration: none;
}
.dropdown-item.active, .dropdown-item.active:hover{
	background-color: inherit;
}
.dropdown-item:hover, .dropdown-item a:hover{
	color: var(--color-menu-hover-text);
	background-color: inherit;
	transition: color .25s;
}
.logo-text {
	font-size: 1.1rem;
	font-weight: 600;
	margin-left: -15px;
	margin-right: 10px;
	margin-bottom: 0;
	color: var(--color-white);
	padding-top: 3px;
}

.sidebar-wrapper {
	width: 270px;
	height: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	background: var(--color-sidebar-bg);
	border-right: 1px solid var(--color-sidebar-border);
	z-index: 11;
	transition: all .2s ease-out
}

.sidebar-header {
	width: 270px;
	height: 45px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	bottom: 0;
	padding: 0 15px;
	z-index: 5;
	background: var(--color-sidebar-bg);
	background-clip: padding-box;
	border-bottom: 1px solid var(--color-sidebar-border);
}
@media screen and (max-width: 768px) {
	.sidebar-wrapper{
		width:100%;
	}
	.sidebar-header{
		width:100%;
	}
}

.sidebar-body{
	overflow-y:auto;
	height: calc(100% - 45px);
}
.sidebar-body::-webkit-scrollbar{
	width:10px;
}
.sidebar-body::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.menu-label {
	padding: 20px 15px 5px 5px;
	color: var(--color-menu-label);
	text-transform: uppercase;
	font-size: 1rem;
	letter-spacing: .5px
}

/* .metismenu .has-arrow:after {
	position: absolute;
	content: "";
	width: .5em;
	height: .5em;
	border-style: solid;
	border-width: 1.2px 0 0 1.2px;
	border-color: initial;
	right: 15px;
	transform: rotate(-45deg) translateY(-50%);
	transform-origin: top;
	top: 50%;
	transition: all .3s ease-out
} */

/* .has-arrow.open:after {
	transform: rotate(-180deg) ;
} */

.rightArrow{
	font-size: .7rem;
	position: absolute;
	top:35%;
	width: .5em;
	height: .5em;
	right: 15px;
	transition: transform .15s;
}
.arrow-flipped{
	transform: translateY(5px) rotate(180deg);
}

@media screen {
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 70px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {
		display: none
	}
	.email-toggle-btn {
		display: none!important
	}
	.chat-toggle-btn {
		display: none!important
	}
}

.sidebar-wrapper ul {
	padding: 0;
	margin: 0;
	list-style: none;
	background: 0 0
}

.sidebar-wrapper .metismenu {
	background: 0 0;
	display: flex;
	padding: 8px;
	padding-top:0;
	flex-direction: column
}

.sidebar-wrapper .metismenu li+li {
	margin-top: 2px
}

.sidebar-wrapper .metismenu li:first-child {
	margin-top: 5px
}

.sidebar-wrapper .metismenu li:last-child {
	margin-bottom: 5px
}
.sidebar-wrapper .metismenu>li {
	display: flex;
	flex-direction: column;
	position: relative
}

.sidebar-wrapper .metismenu a {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: left;
	padding: 8px 15px;
	font-size: 0.875rem;
	color: var(--color-menu-text);
	outline-width: 0;
	text-overflow: ellipsis;
	overflow: hidden;
	letter-spacing: .5px;
	border: 1px solid #ffffff00;
	transition: all .3s ease-out;
    text-decoration: none;
}

.parent-icon {
	color: var(--color-icon-slate);
	font-size: 14px;
	line-height: 1
}

.sidebar-wrapper .metismenu a .menu-title {
	margin-left: 10px;
	margin-top: 5px;
}

.sidebar-wrapper .metismenu ul a {
	padding: 6px 15px 6px 50px;
	font-size: 0.875rem;
	letter-spacing: .5px;
	border: 0
}


.sidebar-wrapper .metismenu ul {
	background: var(--color-sidebar-bg);
}

.sidebar-wrapper .metismenu ul ul a {
	padding: 8px 15px 8px 60px
}

.sidebar-wrapper .metismenu ul ul ul a {
	padding: 8px 15px 8px 45px
}

.sidebar-wrapper .metismenu li button:hover,
.sidebar-wrapper .metismenu li a:hover{
	background-color: var(--color-menu-hover-bg);
	color: var(--color-menu-hover-text);
}
.sidebar-wrapper .metismenu li a,
.sidebar-wrapper .metismenu li button{
	border-radius: 6px;
}
.sidebar-wrapper .metismenu .mm-active>a,
.sidebar-wrapper .metismenu a:active,
.sidebar-wrapper .metismenu a:focus,
.sidebar-wrapper .metismenu a:hover {
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
	text-shadow: none;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    
	background-color: var(--color-menu-active-bg) !important;
    color: var(--color-menu-active-text) !important;
	text-shadow: none;
    border-left: 3px solid var(--color-menu-active-text) !important;
    border-radius: 6px;
}
.sidebar-wrapper .metismenu ul a i {
    margin-right: 10px;
    font-weight: 900;
}

.toggle-icon {
	font-size: 22px;
	cursor:pointer;
	color:var(--color-primary-orange);
	margin-left: 30px;
}
.toggle-icon i{
	margin-left: 70px;
}

.mm-collapse:not(.mm-show) {
    display: none;
}
.mm-collapse li i{
	font-size: 9px;
}
.mm-collapse .parent-icon i{
	font-size: 16px;
}
.mm-collapse.mm-show li .sidebar-button{
	width:100%;
}
.sidebar-button{
	position: relative;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 8px 15px;
    font-size: 0.875rem;
    color: var(--color-menu-text);
    outline-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: .5px;
    border: 1px solid #ffffff00;
    transition: all .3s ease-out;
    text-decoration: none;
	background: none;
}

.padding-left-12{
	padding-left: 12px;
}

.menu-title{
font-weight: 600 !important;
}
.sub-menu-title{
	/* padding-left:13px; */
	font-size:.9rem;
}
.company-logo{
	width: 180px;
	padding: 3px 0px;
}
.company-logo-col{
	width: 40px;
	padding: 3px 0px;
	margin-left: -10px;
}

.dropdown-menu{
	border-radius: 0;
	background-color: var(--color-sidebar-bg);
	box-shadow: 0 4px 12px rgba(0,0,0,0.3);
	max-height: calc(100vh - 390px);
	/* overflow-y: auto;
	overflow-x: hidden; */
}

.dropdown-menu::-webkit-scrollbar{
	width:10px;
	background-color: #3f4349;
}
.dropdown-menu::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.mm-collapse.mm-show .dropdown-item{
	padding-left: 40px;
}
.dropdown-item, .dropdown-item a{
	color: var(--color-menu-text);
	font-size: 0.875rem;
	letter-spacing: .5px;
	height:50px;
	line-height: 52px;
	padding: 0 1rem;
	text-decoration: none;
}
.dropdown-item.active, .dropdown-item.active:hover{
	background-color: inherit;
}
.dropdown-item:hover, .dropdown-item a:hover{
	color: var(--color-menu-hover-text);
	background-color: inherit;
	transition: color .25s;
}
.dropdown-item.header{
	color: var(--color-primary-green);
	font-size: 1.2em;
	background: var(--color-primary-orange) !important;
	padding: 0 1rem 0 2.375rem;
	border-bottom: none;
    box-shadow: inset 1px -7px 0 -7px var(--color-primary-green);}

.collapsed-menu-parent-icon{
	cursor: pointer;
	width: 100%;
	color: var(--color-icon-slate);
	padding: 13px 0;
	font-size: 18px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.collapsed-menu-parent-icon.hovered{
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
}
.collapsed-menu-parent-icon.hovered i{
	color: var(--color-primary-green) !important;
}
.collapsed-menu-parent-icon i{
	color: inherit;
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{
	color: var(--color-menu-active-text) !important;
}

.sidebar-body .metismenu li a.active{
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
	color: var(--color-menu-active-text);
}

.toggle-menu{
	cursor: pointer;
    padding: 22px;
    font-size: 24px;
	color: var(--color-primary-green);
	margin-left: -15px;
}
.toggle-menu:hover{
	text-shadow: 0px 0px 20px var(--color-primary-green);
}
.dropdown-item:focus{
	background-color: inherit;
	color: var(--color-white);
}

.last-child .mm-collapse{
	padding-bottom: 100px;
}
/* --- Sidebar Layer Fix --- */
.sidebar-wrapper,
.sidebar-header {
  position: fixed;
  z-index: 2000 !important;
}

/* Keep main content below the sidebar */
/* .main,
.content-wrapper,
.ticket-info-card,
.card {
  position: relative;
  z-index: 1;
} */

/* Optional: ensure mobile sidebar still stays on top */
@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 100%;
    z-index: 3000 !important;
  }
}
.css-26l3qy-menu {
  z-index: 9999 !important;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-menu-hover-text);
}
.content-wrapper {
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}
.content-wrapper::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
.sidebar-wrapper .metismenu .menu-active .parent-icon,
.sidebar-body .metismenu li a.active .parent-icon,
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu a,
.sidebar-wrapper .metismenu ul a,
.sidebar-wrapper .metismenu ul ul a,
.sidebar-wrapper .metismenu ul ul ul a,
.sidebar-button,
.dropdown-item,
.dropdown-item a,
.menu-title,
.sub-menu-title {
	font-size: 0.9rem !important;
	font-weight: 600 !important;
}

.collapsed-menu-parent-icon{
	cursor: pointer;
	width: 100%;
	color: var(--color-icon-slate);
	padding: 13px 0;
	font-size: 18px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.collapsed-menu-parent-icon.hovered{
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
}
.collapsed-menu-parent-icon.hovered i{
	color: var(--color-primary-green) !important;
}
.collapsed-menu-parent-icon i{
	color: inherit;
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{
	color: var(--color-menu-active-text) !important;
}

.sidebar-body .metismenu li a.active{
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
	color: var(--color-menu-active-text);
}

.toggle-menu{
	cursor: pointer;
    padding: 22px;
    font-size: 24px;
	color: var(--color-primary-green);
}
.toggle-menu:hover{
	text-shadow: 0px 0px 20px var(--color-primary-green);
}
.dropdown-item:focus{
	background-color: inherit;
	color: var(--color-white);
}

.last-child .mm-collapse{
	padding-bottom: 100px;
}
/* --- Sidebar Layer Fix --- */
.sidebar-wrapper,
.sidebar-header {
  position: fixed;
  z-index: 2000 !important;
}

/* Keep main content below the sidebar */
/* .main,
.content-wrapper,
.ticket-info-card,
.card {
  position: relative;
  z-index: 1;
} */

/* Optional: ensure mobile sidebar still stays on top */
@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 100%;
    z-index: 3000 !important;
  }
}
.css-26l3qy-menu {
  z-index: 9999 !important;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-menu-hover-text);
}
.content-wrapper {
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}
.content-wrapper::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
.sidebar-wrapper .metismenu .menu-active .parent-icon,
.sidebar-body .metismenu li a.active .parent-icon,
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu a,
.sidebar-wrapper .metismenu ul a,
.sidebar-wrapper .metismenu ul ul a,
.sidebar-wrapper .metismenu ul ul ul a,
.sidebar-button,
.dropdown-item,
.dropdown-item a,
.menu-title,
.sub-menu-title {
	font-size: 0.9rem !important;
	font-weight: 600 !important;
}
/* Active indicator without layout shift */
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) {
	border-left: none;
	box-shadow: inset 5px 0 0 var(--color-menu-active-text);
}

.sidebar-body .metismenu li a.active {
	border-left: 1px solid transparent;
	box-shadow: inset 5px 0 0 var(--color-menu-active-text);
}

.sidebar-wrapper .metismenu .menu-active,
.menu-active:hover {
	border-left: 1px solid transparent !important;
	box-shadow: inset 3px 0 0 var(--color-menu-active-text);
}
/* Scroll long collapsed-sidebar dropdowns */
.dropdown-menu {
	overflow-y: auto;
	overflow-x: hidden;
	padding-top: 0;
	scrollbar-width: thin;
	scrollbar-color: var(--color-white-a50) transparent;
}
.dropdown-menu::-webkit-scrollbar {
	width: 6px;
	background-color: transparent;
}

/* Keep the menu title visible while scrolling */
.dropdown-item.header {
	position: sticky;
	top: 0;
	z-index: 1;
}
.dropdown-item,
.dropdown-item a {
	line-height: 50px;
}
.dropdown-item a {
	display: block;
}
.dropdown-menu .dropdown-item.header:not(:only-child) {
	border-bottom: 1px solid var(--color-sidebar-border);
	box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/containers/menu/Menu.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,MAAM;CACN,SAAS;CACT,OAAO;CACP,mCAAmC;CACnC,mDAAmD;CACnD,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,MAAM;CACN,SAAS;CACT,eAAe;CACf,UAAU;CACV,mCAAmC;CACnC,4BAA4B;CAC5B,oDAAoD;AACrD;AACA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;GAEG;;AAEH;CACC,gBAAgB;CAChB,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,YAAY;CACZ,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;AACD;;AAEA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CAGf,aAAa;CACb,YAAY;CACZ,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;AACA;CAGC,aAAa;CAIb,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,2BAA2B;CAC3B,4BAA4B;IACzB,qBAAqB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,oBAAoB;CACpB;AACD;;;AAGA;CACC,mCAAmC;AACpC;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,4CAA4C;CAC5C,4CAA4C;AAC7C;AACA;;CAEC,4CAA4C;AAC7C;AACA;;CAEC,kBAAkB;AACnB;AACA;;;;CAIC,6CAA6C;CAC7C,oCAAoC;;CAEpC,iBAAiB;AAClB;AACA;;CAEC,4CAA4C;AAC7C;AACA;CACC,wDAAwD;IACrD,+CAA+C;CAClD,iBAAiB;IACd,+DAA+D;IAC/D,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iCAAiC;CACjC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;CACxB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;AACA;CACC,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,yCAAyC;CACzC,sCAAsC;CACtC,+BAA+B;CAC/B,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,mDAAmD;CACnD,wBAAwB;AACzB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,MAAM;CACN,SAAS;CACT,OAAO;CACP,mCAAmC;CACnC,mDAAmD;CACnD,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,MAAM;CACN,SAAS;CACT,eAAe;CACf,UAAU;CACV,mCAAmC;CACnC,4BAA4B;CAC5B,oDAAoD;AACrD;AACA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;GAEG;;AAEH;CACC,gBAAgB;CAChB,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,YAAY;CACZ,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;AACD;;AAEA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CAGf,aAAa;CACb,YAAY;CACZ,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;AACA;CAGC,aAAa;CAIb,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,2BAA2B;CAC3B,4BAA4B;IACzB,qBAAqB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,oBAAoB;CACpB;AACD;;;AAGA;CACC,mCAAmC;AACpC;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,4CAA4C;CAC5C,mCAAmC;AACpC;AACA;;CAEC,kBAAkB;AACnB;AACA;;;;CAIC,6CAA6C;CAC7C,oCAAoC;;CAEpC,iBAAiB;AAClB;AACA;;CAEC,4CAA4C;AAC7C;AACA;CACC,wDAAwD;IACrD,+CAA+C;CAClD,iBAAiB;IACd,+DAA+D;IAC/D,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iCAAiC;CACjC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;CACxB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;AACA;CACC,uBAAuB;CACvB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,yCAAyC;CACzC,sCAAsC;CACtC,+BAA+B;CAC/B;sBACqB;AACtB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,iCAAiC;CACjC,gBAAgB;CAChB,kDAAkD;CAClD,0BAA0B;CAC1B,mBAAmB;IAChB,4DAA4D,CAAC;;AAEjE;CACC,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,6CAA6C;CAC7C,oCAAoC;;AAErC;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,cAAc;AACf;AACA;CACC,6CAA6C;CAC7C,oDAAoD;AACrD;AACA;CACC,+CAA+C;AAChD;;AAEA;CACC,6CAA6C;CAC7C,oDAAoD;CACpD,oCAAoC;AACrC;;AAEA;CACC,eAAe;IACZ,aAAa;IACb,eAAe;CAClB,iCAAiC;CACjC,kBAAkB;AACnB;AACA;CACC,oDAAoD;AACrD;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA,8BAA8B;AAC9B;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;;;;;;GAMG;;AAEH,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;;CAEC,mCAAmC;AACpC;AACA;EACE,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,aAAa,EAAE,uBAAuB;AACxC;AACA;;;CAGC,4CAA4C;AAC7C;AACA;;;;;;;;;CASC,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,6CAA6C;CAC7C,oCAAoC;;AAErC;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,cAAc;AACf;AACA;CACC,6CAA6C;CAC7C,oDAAoD;AACrD;AACA;CACC,+CAA+C;AAChD;;AAEA;CACC,6CAA6C;CAC7C,oDAAoD;CACpD,oCAAoC;AACrC;;AAEA;CACC,eAAe;IACZ,aAAa;IACb,eAAe;CAClB,iCAAiC;AAClC;AACA;CACC,oDAAoD;AACrD;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA,8BAA8B;AAC9B;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;;;;;;GAMG;;AAEH,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;;CAEC,mCAAmC;AACpC;AACA;EACE,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,aAAa,EAAE,uBAAuB;AACxC;AACA;;;CAGC,4CAA4C;AAC7C;AACA;;;;;;;;;CASC,4BAA4B;CAC5B,2BAA2B;AAC5B;AACA,0CAA0C;AAC1C;CACC,iBAAiB;CACjB,uDAAuD;AACxD;;AAEA;CACC,kCAAkC;CAClC,uDAAuD;AACxD;;AAEA;;CAEC,6CAA6C;CAC7C,uDAAuD;AACxD;AACA,4CAA4C;AAC5C;CACC,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,mDAAmD;AACpD;AACA;CACC,UAAU;CACV,6BAA6B;AAC9B;;AAEA,gDAAgD;AAChD;CACC,gBAAgB;CAChB,MAAM;CACN,UAAU;AACX;AACA;;CAEC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,oDAAoD;CACpD,gBAAgB;AACjB","sourcesContent":[".logo-text {\n\tfont-size: 1.1rem;\n\tfont-weight: 600;\n\tmargin-left: -15px;\n\tmargin-right: 10px;\n\tmargin-bottom: 0;\n\tcolor: var(--color-primary-green) !important;\n\tpadding-top: 3px;\n}\n\n.sidebar-wrapper {\n\twidth: 270px;\n\theight: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground: var(--color-sidebar-bg);\n\tborder-right: 1px solid var(--color-sidebar-border);\n\tz-index: 11;\n\ttransition: all .2s ease-out\n}\n\n.sidebar-header {\n\twidth: 270px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tpadding: 0 15px;\n\tz-index: 5;\n\tbackground: var(--color-sidebar-bg);\n\tbackground-clip: padding-box;\n\tborder-bottom: 1px solid var(--color-sidebar-border);\n}\n@media screen and (max-width: 768px) {\n\t.sidebar-wrapper{\n\t\twidth:100%;\n\t}\n\t.sidebar-header{\n\t\twidth:100%;\n\t}\n}\n\n.sidebar-body{\n\toverflow-y:auto;\n\theight: calc(100% - 45px);\n}\n.sidebar-body::-webkit-scrollbar{\n\twidth:10px;\n}\n.sidebar-body::-webkit-scrollbar-thumb{\n\tbackground-color: var(--color-white-a50);\n\tborder-radius: 5px;\n}\n.menu-label {\n\tpadding: 20px 15px 5px 5px;\n\tcolor: var(--color-menu-label);\n\ttext-transform: uppercase;\n\tfont-size: 1rem;\n\tletter-spacing: .5px\n}\n\n/* .metismenu .has-arrow:after {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: .5em;\n\theight: .5em;\n\tborder-style: solid;\n\tborder-width: 1.2px 0 0 1.2px;\n\tborder-color: initial;\n\tright: 15px;\n\ttransform: rotate(-45deg) translateY(-50%);\n\ttransform-origin: top;\n\ttop: 50%;\n\ttransition: all .3s ease-out\n} */\n\n/* .has-arrow.open:after {\n\ttransform: rotate(-180deg) ;\n} */\n\n.rightArrow{\n\tfont-size: .7rem;\n\tposition: absolute;\n\ttop:35%;\n\twidth: .5em;\n\theight: .5em;\n\tright: 15px;\n\ttransition: transform .15s;\n}\n.arrow-flipped{\n\ttransform: translateY(5px) rotate(180deg);\n}\n\n@media screen {\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {\n\t\twidth: 55px\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\n\t\twidth: 55px\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\n\t\tjustify-content: center\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\n\t\twidth: 70px\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {\n\t\tjustify-content: center\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {\n\t\tdisplay: none\n\t}\n\t.email-toggle-btn {\n\t\tdisplay: none!important\n\t}\n\t.chat-toggle-btn {\n\t\tdisplay: none!important\n\t}\n}\n\n.sidebar-wrapper ul {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n\tbackground: 0 0\n}\n\n.sidebar-wrapper .metismenu {\n\tbackground: 0 0;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tpadding: 8px;\n\tpadding-top:0;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column\n}\n\n.sidebar-wrapper .metismenu li+li {\n\tmargin-top: 2px\n}\n\n.sidebar-wrapper .metismenu li:first-child {\n\tmargin-top: 5px\n}\n\n.sidebar-wrapper .metismenu li:last-child {\n\tmargin-bottom: 5px\n}\n.sidebar-wrapper .metismenu>li {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tposition: relative\n}\n\n.sidebar-wrapper .metismenu a {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: left;\n\tpadding: 8px 15px;\n\tfont-size: 0.875rem;\n\tcolor: var(--color-menu-text);\n\toutline-width: 0;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tletter-spacing: .5px;\n\tborder: 1px solid #ffffff00;\n\ttransition: all .3s ease-out;\n    text-decoration: none;\n}\n\n.parent-icon {\n\tcolor: var(--color-icon-slate);\n\tfont-size: 14px;\n\tline-height: 1\n}\n\n.sidebar-wrapper .metismenu a .menu-title {\n\tmargin-left: 10px;\n\tmargin-top: 5px;\n}\n\n.sidebar-wrapper .metismenu ul a {\n\tpadding: 6px 15px 6px 50px;\n\tfont-size: 0.875rem;\n\tletter-spacing: .5px;\n\tborder: 0\n}\n\n\n.sidebar-wrapper .metismenu ul {\n\tbackground: var(--color-sidebar-bg);\n}\n\n.sidebar-wrapper .metismenu ul ul a {\n\tpadding: 8px 15px 8px 60px\n}\n\n.sidebar-wrapper .metismenu ul ul ul a {\n\tpadding: 8px 15px 8px 45px\n}\n\n.sidebar-wrapper .metismenu li button:hover,\n.sidebar-wrapper .metismenu li a:hover{\n\tbackground-color: var(--color-menu-hover-bg);\n\tcolor: var(--color-primary-green) !important;\n}\n.sidebar-wrapper .metismenu li button:hover .menu-title,\n.sidebar-wrapper .metismenu li a:hover .menu-title{\n\tcolor: var(--color-primary-green) !important;\n}\n.sidebar-wrapper .metismenu li a,\n.sidebar-wrapper .metismenu li button{\n\tborder-radius: 6px;\n}\n.sidebar-wrapper .metismenu .mm-active>a,\n.sidebar-wrapper .metismenu a:active,\n.sidebar-wrapper .metismenu a:focus,\n.sidebar-wrapper .metismenu a:hover {\n\tbackground-color: var(--color-menu-active-bg);\n\tcolor: var(--color-menu-active-text);\n\t\n\ttext-shadow: none;\n}\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\n\tcolor: var(--color-primary-green) !important;\n}\n.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    \n\tbackground-color: var(--color-menu-active-bg) !important;\n    color: var(--color-menu-active-text) !important;\n\ttext-shadow: none;\n    border-left: 3px solid var(--color-menu-active-text) !important;\n    border-radius: 6px;\n}\n.sidebar-wrapper .metismenu ul a i {\n    margin-right: 10px;\n    font-weight: 900;\n}\n\n.toggle-icon {\n\tfont-size: 22px;\n\tcursor:pointer;\n\tcolor:var(--color-primary-orange);\n\tmargin-left: 30px;\n}\n.toggle-icon i{\n\tmargin-left: 70px;\n}\n\n.mm-collapse:not(.mm-show) {\n    display: none;\n}\n.mm-collapse li i{\n\tfont-size: 9px;\n}\n.mm-collapse .parent-icon i{\n\tfont-size: 16px;\n}\n.mm-collapse.mm-show li .sidebar-button{\n\twidth:100%;\n}\n.sidebar-button{\n\tposition: relative;\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    padding: 8px 15px;\n    font-size: 0.875rem;\n    color: var(--color-menu-text);\n    outline-width: 0;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    letter-spacing: .5px;\n    border: 1px solid #ffffff00;\n    transition: all .3s ease-out;\n    text-decoration: none;\n\tbackground: none;\n}\n\n.padding-left-12{\n\tpadding-left: 12px;\n}\n\n.menu-title{\nfont-weight: 600 !important;\n}\n.sub-menu-title{\n\t/* padding-left:13px; */\n\tfont-size:.9rem;\n}\n\n.dropdown-menu{\n\tborder-radius: 0;\n\tbackground-color: var(--color-sidebar-bg);\n\tbox-shadow: 0 4px 12px rgba(0,0,0,0.3);\n\tmax-height: calc(100vh - 390px);\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tpadding-top: 0;\n\tscrollbar-width: thin;\n\tscrollbar-color: var(--color-white-a50) transparent;\n\tscrollbar-gutter: stable;\n}\n.dropdown-item {\n\twhite-space: nowrap;\n}\n\n.dropdown-menu::-webkit-scrollbar{\n\twidth:10px;\n\tbackground-color: #3f4349;\n}\n.dropdown-menu::-webkit-scrollbar-thumb{\n\tbackground-color: var(--color-white-a50);\n\tborder-radius: 5px;\n}\n.mm-collapse.mm-show .dropdown-item{\n\tpadding-left: 40px;\n}\n.dropdown-item, .dropdown-item a{\n\tcolor: var(--color-menu-text);\n\tfont-size: 0.875rem;\n\tletter-spacing: .5px;\n\theight:50px;\n\tline-height: 52px;\n\tpadding: 0 1rem;\n\ttext-decoration: none;\n}\n.dropdown-item.active, .dropdown-item.active:hover{\n\tbackground-color: inherit;\n}\n.dropdown-item:hover, .dropdown-item a:hover{\n\tcolor: var(--color-menu-hover-text);\n\tbackground-color: inherit;\n\ttransition: color .25s;\n}\n.logo-text {\n\tfont-size: 1.1rem;\n\tfont-weight: 600;\n\tmargin-left: -15px;\n\tmargin-right: 10px;\n\tmargin-bottom: 0;\n\tcolor: var(--color-white);\n\tpadding-top: 3px;\n}\n\n.sidebar-wrapper {\n\twidth: 270px;\n\theight: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground: var(--color-sidebar-bg);\n\tborder-right: 1px solid var(--color-sidebar-border);\n\tz-index: 11;\n\ttransition: all .2s ease-out\n}\n\n.sidebar-header {\n\twidth: 270px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tpadding: 0 15px;\n\tz-index: 5;\n\tbackground: var(--color-sidebar-bg);\n\tbackground-clip: padding-box;\n\tborder-bottom: 1px solid var(--color-sidebar-border);\n}\n@media screen and (max-width: 768px) {\n\t.sidebar-wrapper{\n\t\twidth:100%;\n\t}\n\t.sidebar-header{\n\t\twidth:100%;\n\t}\n}\n\n.sidebar-body{\n\toverflow-y:auto;\n\theight: calc(100% - 45px);\n}\n.sidebar-body::-webkit-scrollbar{\n\twidth:10px;\n}\n.sidebar-body::-webkit-scrollbar-thumb{\n\tbackground-color: var(--color-white-a50);\n\tborder-radius: 5px;\n}\n.menu-label {\n\tpadding: 20px 15px 5px 5px;\n\tcolor: var(--color-menu-label);\n\ttext-transform: uppercase;\n\tfont-size: 1rem;\n\tletter-spacing: .5px\n}\n\n/* .metismenu .has-arrow:after {\n\tposition: absolute;\n\tcontent: \"\";\n\twidth: .5em;\n\theight: .5em;\n\tborder-style: solid;\n\tborder-width: 1.2px 0 0 1.2px;\n\tborder-color: initial;\n\tright: 15px;\n\ttransform: rotate(-45deg) translateY(-50%);\n\ttransform-origin: top;\n\ttop: 50%;\n\ttransition: all .3s ease-out\n} */\n\n/* .has-arrow.open:after {\n\ttransform: rotate(-180deg) ;\n} */\n\n.rightArrow{\n\tfont-size: .7rem;\n\tposition: absolute;\n\ttop:35%;\n\twidth: .5em;\n\theight: .5em;\n\tright: 15px;\n\ttransition: transform .15s;\n}\n.arrow-flipped{\n\ttransform: translateY(5px) rotate(180deg);\n}\n\n@media screen {\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {\n\t\twidth: 55px\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\n\t\twidth: 55px\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\n\t\tjustify-content: center\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\n\t\twidth: 70px\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {\n\t\tjustify-content: center\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {\n\t\tdisplay: none\n\t}\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {\n\t\tdisplay: none\n\t}\n\t.email-toggle-btn {\n\t\tdisplay: none!important\n\t}\n\t.chat-toggle-btn {\n\t\tdisplay: none!important\n\t}\n}\n\n.sidebar-wrapper ul {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n\tbackground: 0 0\n}\n\n.sidebar-wrapper .metismenu {\n\tbackground: 0 0;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tpadding: 8px;\n\tpadding-top:0;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column\n}\n\n.sidebar-wrapper .metismenu li+li {\n\tmargin-top: 2px\n}\n\n.sidebar-wrapper .metismenu li:first-child {\n\tmargin-top: 5px\n}\n\n.sidebar-wrapper .metismenu li:last-child {\n\tmargin-bottom: 5px\n}\n.sidebar-wrapper .metismenu>li {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tposition: relative\n}\n\n.sidebar-wrapper .metismenu a {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: left;\n\tpadding: 8px 15px;\n\tfont-size: 0.875rem;\n\tcolor: var(--color-menu-text);\n\toutline-width: 0;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tletter-spacing: .5px;\n\tborder: 1px solid #ffffff00;\n\ttransition: all .3s ease-out;\n    text-decoration: none;\n}\n\n.parent-icon {\n\tcolor: var(--color-icon-slate);\n\tfont-size: 14px;\n\tline-height: 1\n}\n\n.sidebar-wrapper .metismenu a .menu-title {\n\tmargin-left: 10px;\n\tmargin-top: 5px;\n}\n\n.sidebar-wrapper .metismenu ul a {\n\tpadding: 6px 15px 6px 50px;\n\tfont-size: 0.875rem;\n\tletter-spacing: .5px;\n\tborder: 0\n}\n\n\n.sidebar-wrapper .metismenu ul {\n\tbackground: var(--color-sidebar-bg);\n}\n\n.sidebar-wrapper .metismenu ul ul a {\n\tpadding: 8px 15px 8px 60px\n}\n\n.sidebar-wrapper .metismenu ul ul ul a {\n\tpadding: 8px 15px 8px 45px\n}\n\n.sidebar-wrapper .metismenu li button:hover,\n.sidebar-wrapper .metismenu li a:hover{\n\tbackground-color: var(--color-menu-hover-bg);\n\tcolor: var(--color-menu-hover-text);\n}\n.sidebar-wrapper .metismenu li a,\n.sidebar-wrapper .metismenu li button{\n\tborder-radius: 6px;\n}\n.sidebar-wrapper .metismenu .mm-active>a,\n.sidebar-wrapper .metismenu a:active,\n.sidebar-wrapper .metismenu a:focus,\n.sidebar-wrapper .metismenu a:hover {\n\tbackground-color: var(--color-menu-active-bg);\n\tcolor: var(--color-menu-active-text);\n\t\n\ttext-shadow: none;\n}\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\n\tcolor: var(--color-primary-green) !important;\n}\n.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    \n\tbackground-color: var(--color-menu-active-bg) !important;\n    color: var(--color-menu-active-text) !important;\n\ttext-shadow: none;\n    border-left: 3px solid var(--color-menu-active-text) !important;\n    border-radius: 6px;\n}\n.sidebar-wrapper .metismenu ul a i {\n    margin-right: 10px;\n    font-weight: 900;\n}\n\n.toggle-icon {\n\tfont-size: 22px;\n\tcursor:pointer;\n\tcolor:var(--color-primary-orange);\n\tmargin-left: 30px;\n}\n.toggle-icon i{\n\tmargin-left: 70px;\n}\n\n.mm-collapse:not(.mm-show) {\n    display: none;\n}\n.mm-collapse li i{\n\tfont-size: 9px;\n}\n.mm-collapse .parent-icon i{\n\tfont-size: 16px;\n}\n.mm-collapse.mm-show li .sidebar-button{\n\twidth:100%;\n}\n.sidebar-button{\n\tposition: relative;\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    padding: 8px 15px;\n    font-size: 0.875rem;\n    color: var(--color-menu-text);\n    outline-width: 0;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    letter-spacing: .5px;\n    border: 1px solid #ffffff00;\n    transition: all .3s ease-out;\n    text-decoration: none;\n\tbackground: none;\n}\n\n.padding-left-12{\n\tpadding-left: 12px;\n}\n\n.menu-title{\nfont-weight: 600 !important;\n}\n.sub-menu-title{\n\t/* padding-left:13px; */\n\tfont-size:.9rem;\n}\n.company-logo{\n\twidth: 180px;\n\tpadding: 3px 0px;\n}\n.company-logo-col{\n\twidth: 40px;\n\tpadding: 3px 0px;\n\tmargin-left: -10px;\n}\n\n.dropdown-menu{\n\tborder-radius: 0;\n\tbackground-color: var(--color-sidebar-bg);\n\tbox-shadow: 0 4px 12px rgba(0,0,0,0.3);\n\tmax-height: calc(100vh - 390px);\n\t/* overflow-y: auto;\n\toverflow-x: hidden; */\n}\n\n.dropdown-menu::-webkit-scrollbar{\n\twidth:10px;\n\tbackground-color: #3f4349;\n}\n.dropdown-menu::-webkit-scrollbar-thumb{\n\tbackground-color: var(--color-white-a50);\n\tborder-radius: 5px;\n}\n.mm-collapse.mm-show .dropdown-item{\n\tpadding-left: 40px;\n}\n.dropdown-item, .dropdown-item a{\n\tcolor: var(--color-menu-text);\n\tfont-size: 0.875rem;\n\tletter-spacing: .5px;\n\theight:50px;\n\tline-height: 52px;\n\tpadding: 0 1rem;\n\ttext-decoration: none;\n}\n.dropdown-item.active, .dropdown-item.active:hover{\n\tbackground-color: inherit;\n}\n.dropdown-item:hover, .dropdown-item a:hover{\n\tcolor: var(--color-menu-hover-text);\n\tbackground-color: inherit;\n\ttransition: color .25s;\n}\n.dropdown-item.header{\n\tcolor: var(--color-primary-green);\n\tfont-size: 1.2em;\n\tbackground: var(--color-primary-orange) !important;\n\tpadding: 0 1rem 0 2.375rem;\n\tborder-bottom: none;\n    box-shadow: inset 1px -7px 0 -7px var(--color-primary-green);}\n\n.collapsed-menu-parent-icon{\n\tcursor: pointer;\n\twidth: 100%;\n\tcolor: var(--color-icon-slate);\n\tpadding: 13px 0;\n\tfont-size: 18px;\n\tborder-radius: 6px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.collapsed-menu-parent-icon.hovered{\n\tbackground-color: var(--color-menu-active-bg);\n\tcolor: var(--color-menu-active-text);\n\t\n}\n.collapsed-menu-parent-icon.hovered i{\n\tcolor: var(--color-primary-green) !important;\n}\n.collapsed-menu-parent-icon i{\n\tcolor: inherit;\n}\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){\n\tbackground-color: var(--color-menu-active-bg);\n\tborder-left: 5px solid var(--color-menu-active-text);\n}\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{\n\tcolor: var(--color-menu-active-text) !important;\n}\n\n.sidebar-body .metismenu li a.active{\n\tbackground-color: var(--color-menu-active-bg);\n\tborder-left: 5px solid var(--color-menu-active-text);\n\tcolor: var(--color-menu-active-text);\n}\n\n.toggle-menu{\n\tcursor: pointer;\n    padding: 22px;\n    font-size: 24px;\n\tcolor: var(--color-primary-green);\n\tmargin-left: -15px;\n}\n.toggle-menu:hover{\n\ttext-shadow: 0px 0px 20px var(--color-primary-green);\n}\n.dropdown-item:focus{\n\tbackground-color: inherit;\n\tcolor: var(--color-white);\n}\n\n.last-child .mm-collapse{\n\tpadding-bottom: 100px;\n}\n/* --- Sidebar Layer Fix --- */\n.sidebar-wrapper,\n.sidebar-header {\n  position: fixed;\n  z-index: 2000 !important;\n}\n\n/* Keep main content below the sidebar */\n/* .main,\n.content-wrapper,\n.ticket-info-card,\n.card {\n  position: relative;\n  z-index: 1;\n} */\n\n/* Optional: ensure mobile sidebar still stays on top */\n@media (max-width: 768px) {\n  .sidebar-wrapper {\n    width: 100%;\n    z-index: 3000 !important;\n  }\n}\n.css-26l3qy-menu {\n  z-index: 9999 !important;\n}\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\n\tcolor: var(--color-menu-hover-text);\n}\n.content-wrapper {\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n}\n.content-wrapper::-webkit-scrollbar {\n  display: none; /* Chrome/Safari/Edge */\n}\n.sidebar-wrapper .metismenu .menu-active .parent-icon,\n.sidebar-body .metismenu li a.active .parent-icon,\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {\n\tcolor: var(--color-primary-green) !important;\n}\n.sidebar-wrapper .metismenu a,\n.sidebar-wrapper .metismenu ul a,\n.sidebar-wrapper .metismenu ul ul a,\n.sidebar-wrapper .metismenu ul ul ul a,\n.sidebar-button,\n.dropdown-item,\n.dropdown-item a,\n.menu-title,\n.sub-menu-title {\n\tfont-size: 0.9rem !important;\n\tfont-weight: 600 !important;\n}\n\n.collapsed-menu-parent-icon{\n\tcursor: pointer;\n\twidth: 100%;\n\tcolor: var(--color-icon-slate);\n\tpadding: 13px 0;\n\tfont-size: 18px;\n\tborder-radius: 6px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.collapsed-menu-parent-icon.hovered{\n\tbackground-color: var(--color-menu-active-bg);\n\tcolor: var(--color-menu-active-text);\n\t\n}\n.collapsed-menu-parent-icon.hovered i{\n\tcolor: var(--color-primary-green) !important;\n}\n.collapsed-menu-parent-icon i{\n\tcolor: inherit;\n}\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){\n\tbackground-color: var(--color-menu-active-bg);\n\tborder-left: 5px solid var(--color-menu-active-text);\n}\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{\n\tcolor: var(--color-menu-active-text) !important;\n}\n\n.sidebar-body .metismenu li a.active{\n\tbackground-color: var(--color-menu-active-bg);\n\tborder-left: 5px solid var(--color-menu-active-text);\n\tcolor: var(--color-menu-active-text);\n}\n\n.toggle-menu{\n\tcursor: pointer;\n    padding: 22px;\n    font-size: 24px;\n\tcolor: var(--color-primary-green);\n}\n.toggle-menu:hover{\n\ttext-shadow: 0px 0px 20px var(--color-primary-green);\n}\n.dropdown-item:focus{\n\tbackground-color: inherit;\n\tcolor: var(--color-white);\n}\n\n.last-child .mm-collapse{\n\tpadding-bottom: 100px;\n}\n/* --- Sidebar Layer Fix --- */\n.sidebar-wrapper,\n.sidebar-header {\n  position: fixed;\n  z-index: 2000 !important;\n}\n\n/* Keep main content below the sidebar */\n/* .main,\n.content-wrapper,\n.ticket-info-card,\n.card {\n  position: relative;\n  z-index: 1;\n} */\n\n/* Optional: ensure mobile sidebar still stays on top */\n@media (max-width: 768px) {\n  .sidebar-wrapper {\n    width: 100%;\n    z-index: 3000 !important;\n  }\n}\n.css-26l3qy-menu {\n  z-index: 9999 !important;\n}\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\n\tcolor: var(--color-menu-hover-text);\n}\n.content-wrapper {\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n}\n.content-wrapper::-webkit-scrollbar {\n  display: none; /* Chrome/Safari/Edge */\n}\n.sidebar-wrapper .metismenu .menu-active .parent-icon,\n.sidebar-body .metismenu li a.active .parent-icon,\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {\n\tcolor: var(--color-primary-green) !important;\n}\n.sidebar-wrapper .metismenu a,\n.sidebar-wrapper .metismenu ul a,\n.sidebar-wrapper .metismenu ul ul a,\n.sidebar-wrapper .metismenu ul ul ul a,\n.sidebar-button,\n.dropdown-item,\n.dropdown-item a,\n.menu-title,\n.sub-menu-title {\n\tfont-size: 0.9rem !important;\n\tfont-weight: 600 !important;\n}\n/* Active indicator without layout shift */\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) {\n\tborder-left: none;\n\tbox-shadow: inset 5px 0 0 var(--color-menu-active-text);\n}\n\n.sidebar-body .metismenu li a.active {\n\tborder-left: 1px solid transparent;\n\tbox-shadow: inset 5px 0 0 var(--color-menu-active-text);\n}\n\n.sidebar-wrapper .metismenu .menu-active,\n.menu-active:hover {\n\tborder-left: 1px solid transparent !important;\n\tbox-shadow: inset 3px 0 0 var(--color-menu-active-text);\n}\n/* Scroll long collapsed-sidebar dropdowns */\n.dropdown-menu {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tpadding-top: 0;\n\tscrollbar-width: thin;\n\tscrollbar-color: var(--color-white-a50) transparent;\n}\n.dropdown-menu::-webkit-scrollbar {\n\twidth: 6px;\n\tbackground-color: transparent;\n}\n\n/* Keep the menu title visible while scrolling */\n.dropdown-item.header {\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 1;\n}\n.dropdown-item,\n.dropdown-item a {\n\tline-height: 50px;\n}\n.dropdown-item a {\n\tdisplay: block;\n}\n.dropdown-menu .dropdown-item.header:not(:only-child) {\n\tborder-bottom: 1px solid var(--color-sidebar-border);\n\tbox-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
